import { createTranslations } from '@/i18n/types';

const translations = createTranslations({
  en: {
    title: 'Achievements',
    achievementsTitle: 'Trophies',
    counter: '{earned} / {total}',
    locked: 'Nothing earned yet',
    loading: 'Loading…',
    userNotFound: 'User not found',
    loadFailed: 'Failed to load achievements',
    secret: 'Secret achievement',
    unlockedAt: 'Earned {date}',
    progress: 'Progress',
    ownedByPercent: '{{percent}}% of players have it',
    reward: 'Reward',
    claimReward: 'Claim reward',
    depositToUnlock: 'Deposit to unlock',
    recentReceivers: 'Recently earned by',
    noOneUnlocked: 'Nobody earned this yet',
    you: 'You',
    today: 'Today',
    receivedBy: 'Earned by',
    playerOne: 'player',
    playerFew: 'players',
    playerMany: 'players',
    achievementUnlocked: 'Achievement unlocked: {title}',
    achievementUnlockedFallback: 'Achievement unlocked!',
    whatIsThis: 'What is this?',
    categoryAll: 'All',
    categoryCases: 'Cases',
    categoryUpgrades: 'Upgrades',
    categoryContracts: 'Contracts',
    categoryDeposits: 'Deposits',
    categorySteam: 'Steam',
    categoryFriends: 'Friends',
    categoryActivity: 'Activity',
    categorySecret: 'Secret',
    categoryRushmid: 'Rush Mid',
    legendCredited: 'Credited',
    legendUnclaimed: 'Reward pending',
  },
  ru: {
    title: 'Трофеи',
    achievementsTitle: 'Трофеи',
    counter: '{earned} / {total}',
    locked: 'Пока ничего не получено',
    loading: 'Загрузка…',
    userNotFound: 'Пользователь не найден',
    loadFailed: 'Не удалось загрузить достижения',
    secret: 'Секретная ачивка',
    unlockedAt: 'Получено {date}',
    progress: 'Прогресс',
    ownedByPercent: 'Есть у {{percent}}% игроков',
    reward: 'Награда',
    claimReward: 'Забрать награду',
    depositToUnlock: 'Пополни, чтобы забрать',
    recentReceivers: 'Недавно получили',
    noOneUnlocked: 'Пока никто не получил',
    you: 'Ты',
    today: 'Сегодня',
    receivedBy: 'Получили:',
    playerOne: 'игрок',
    playerFew: 'игрока',
    playerMany: 'игроков',
    achievementUnlocked: 'Получена ачивка: {title}',
    achievementUnlockedFallback: 'Ачивка получена!',
    whatIsThis: 'Что это такое?',
    categoryAll: 'Все',
    categoryCases: 'Кейсы',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Контракты',
    categoryDeposits: 'Пополнения',
    categorySteam: 'Steam',
    categoryFriends: 'Друзья',
    categoryActivity: 'Активность',
    categorySecret: 'Секретные',
    categoryRushmid: 'Rush Mid',
    legendCredited: 'Зачислено',
    legendUnclaimed: 'Награда ждёт',
  },
  uz: {
    title: 'Yutuqlar',
    achievementsTitle: 'Kuboklar',
    counter: '{earned} / {total}',
    locked: 'Hali hech narsa olinmagan',
    loading: 'Yuklanmoqda…',
    userNotFound: 'Foydalanuvchi topilmadi',
    loadFailed: 'Yutuqlarni yuklab boʻlmadi',
    secret: 'Maxfiy yutuq',
    unlockedAt: '{date} da olindi',
    progress: 'Jarayon',
    ownedByPercent: 'Oʻyinchilarning {{percent}}% da bor',
    reward: 'Mukofot',
    claimReward: 'Mukofotni olish',
    depositToUnlock: 'Olish uchun toʻldir',
    recentReceivers: 'Yaqinda oldilar',
    noOneUnlocked: 'Hali hech kim olmadi',
    you: 'Sen',
    today: 'Bugun',
    receivedBy: 'Oldi:',
    playerOne: 'oʻyinchi',
    playerFew: 'oʻyinchi',
    playerMany: 'oʻyinchi',
    achievementUnlocked: 'Yutuq ochildi: {title}',
    achievementUnlockedFallback: 'Yutuq ochildi!',
    whatIsThis: 'Bu nima?',
    categoryAll: 'Barchasi',
    categoryCases: 'Keyslar',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Kontraktlar',
    categoryDeposits: 'Toʻldirish',
    categorySteam: 'Steam',
    categoryFriends: 'Doʻstlar',
    categoryActivity: 'Faollik',
    categorySecret: 'Maxfiy',
    categoryRushmid: 'Rush Mid',
    legendCredited: 'Hisoblandi',
    legendUnclaimed: 'Mukofot kutilmoqda',
  },
  fa: {
    title: 'دستاوردها',
    achievementsTitle: 'جام‌ها',
    counter: '{earned} / {total}',
    locked: 'هنوز چیزی نگرفته‌ای',
    loading: 'در حال بارگذاری…',
    userNotFound: 'کاربر پیدا نشد',
    loadFailed: 'دستاوردها بارگذاری نشدند',
    secret: 'دستاورد مخفی',
    unlockedAt: 'گرفته‌شده در {date}',
    progress: 'پیشرفت',
    ownedByPercent: '{{percent}}% بازیکنان دارندش',
    reward: 'جایزه',
    claimReward: 'جایزه را بگیر',
    depositToUnlock: 'برای باز شدن شارژ کن',
    recentReceivers: 'به‌تازگی گرفته‌اند',
    noOneUnlocked: 'هنوز کسی این را نگرفته',
    you: 'تو',
    today: 'امروز',
    receivedBy: 'گرفته‌شده توسط',
    playerOne: 'بازیکن',
    playerFew: 'بازیکن',
    playerMany: 'بازیکن',
    achievementUnlocked: 'دستاورد باز شد: {title}',
    achievementUnlockedFallback: 'دستاورد باز شد!',
    whatIsThis: 'این چیست؟',
    categoryAll: 'همه',
    categoryCases: 'کیس‌ها',
    categoryUpgrades: 'ارتقاها',
    categoryContracts: 'قراردادها',
    categoryDeposits: 'شارژها',
    categorySteam: 'استیم',
    categoryFriends: 'دوستان',
    categoryActivity: 'فعالیت',
    categorySecret: 'مخفی',
    categoryRushmid: 'Rush Mid',
    legendCredited: 'واریز‌شده',
    legendUnclaimed: 'جایزه در انتظار',
  },
});

export default translations;
